import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ContactsPage.css';

// Import components (we'll create these next)
import SuppliersTable from '../components/contacts/SuppliersTable';
import CustomersTable from '../components/contacts/CustomersTable';

const ContactsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get active tab from URL or default to suppliers
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/customers')) return 'customers';
    return 'suppliers';
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Update URL to reflect active tab
    if (tab === 'customers') {
      navigate('/contacts/customers');
    } else {
      navigate('/contacts/suppliers');
    }
  };

  const tabs = [
    { key: 'suppliers', label: 'Suppliers', icon: '🏭' },
    { key: 'customers', label: 'Customers', icon: '👥' }
  ];

  return (
    <div className="contacts-page">
      <div className="contacts-header">
        <h1>Contacts</h1>
        <p>Manage your suppliers and customers</p>
      </div>

      <div className="contacts-tabs">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => handleTabChange(tab.key)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="contacts-content">
        {activeTab === 'suppliers' && <SuppliersTable />}
        {activeTab === 'customers' && <CustomersTable />}
      </div>
    </div>
  );
};

export default ContactsPage;
